import React, { useState } from "react";
import FormContainer from './FormContainer';
import { useNavigate } from "react-router-dom"
import { useSnackbar } from 'notistack';
import { ForgotPasswordAPI } from "../../API/auth";
import Swal from "sweetalert2";
function ForgotPassword() {
    let navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [value, setEmail] = useState({
        email: ''
    });
    const [error, setError] = useState('');
    const HandelChange = (event) => {
        setEmail({
            email: event.target.value
        });
        console.log(event.target);
    }   
    const HandelSubmit = async (event) => {
        event.preventDefault();
        let res = await ForgotPasswordAPI(value);
        if (res.data.status) {
            Swal.fire({
                title: "Password Reset Link Sent",
                text: "A password reset link has been sent to the email address you provided. If you don’t see it in your inbox, please check your spam folder.",
                icon: "success",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                cancelButtonText: "Close"

            })
            // enqueueSnackbar(res.data.message, {
            //     variant: 'success', action: (key) => (
            //         <button className='toast_close_btn'
            //             onClick={() => {
            //                 // Close the Snackbar
            //                 closeSnackbar(key);
            //             }}
            //         >
            //             X
            //         </button>
            //     ),
            // });
        } else {
            Swal.fire({
                title: "Email Not Found",
                text: "We couldn’t find an account associated with the email you provided. Please check the email address and try again.",
                icon: "error",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                cancelButtonText: "Close"

            })
            // setError(res.data.message);
        }
    }
    return (
        <>
            <FormContainer>
                <form className="mt-3 login-form" onSubmit={HandelSubmit}>
                    <label className="form-title mb-2">  FORGET PASSWORD</label>
                    <p className="form-heading mb-3" style={{marginTop:"-6px"}} >
                        Please enter your email address we will send you a link to reset your password.
                    </p>
                    <div data-mdb-input-init="" className="form-outline mb-4">
                        <label className='mb-3 input-label' htmlFor="email">Email address</label>
                        <input
                            type="email"
                            id="form2Example18"
                            placeholder="Email"
                            name="email"
                            className="form-control bg-transparent form-input"
                            onChange={HandelChange}
                            value={value.email}
                        />
                        {error && <span className='text-danger'>{error}</span>}

                    </div>
                    <div className="pt-1 mb-4">
                        <button
                            className="btn btn-light w-100 border-0 px-3 py-3 fs-5 text-white submit-button" type="submit" >  Continue </button>
                    </div>
                </form>
            </FormContainer>
        </>
    )
}
export default ForgotPassword;